const _i18n_info = {
  time_setting : {
    EN: `Time setting`,
    KO: `Time setting`,
    JP: `時間設定`
  },
  check_duplicate : {
    EN: `This item already exists`,
    KO: `This item already exists`,
    JP: `この項目はすでに存在します`
  }
}

const _i18n_warning = {
  schedule_check : {
    EN: `is not hh:mm time format`,
    KO: `is not hh:mm time format`,
    JP: `hh:mm の時刻形式ではありません`
  }
}

const i18n_toastr = {
  _i18n_info,
  _i18n_warning
}

export default i18n_toastr